import { AbstractListService } from '@/core/services/list.service'
import { AbstractEditService } from '@/core/services/edit.service'
import { ListFetchOptions } from '@/core/typing'
import { AbstractSearchService } from '@/core/services/search.service'

class List extends AbstractListService<Store> {
  getFetchURL(): string {
    return 'admin'
  }
  getSearchParams(): any {
    return this.context.search.getSearchParams()
  }
}
class Search extends AbstractSearchService<Store> {
  onSubmit(): void {
    this.context.list.fetch({ reset: true })
  }
}

class Edit extends AbstractEditService<Store> {
  roles = []

  getFetchURL() {
    return `admin/${this.params.id}`
  }
  getDefaultFormData() {
    return { role_ids: [] }
  }

  getSubmitURL(): string {
    return this.isEdit ? `admin/${this.params.id}` : 'admin'
  }
  getRemoveURL(): string {
    return `admin/${this.params.id}`
  }
  requestListReload(option?: ListFetchOptions): void {
    this.context.list.fetch(option)
  }
}

class Store {
  list: List
  search: Search
  edit: Edit

  constructor() {
    this.list = new List(this)
    this.search = new Search(this)
    this.edit = new Edit(this)
  }
}

export const store = new Store()
